import Cookies from 'js-cookie';

export const setToken = async (token: string) => {
  const expirationTime = new Date(Date.now() + 12 * 60 * 1000);
  Cookies.set('auth_token', token, { expires: expirationTime });
};
